import React, { useState, useEffect } from "react";
import { Search, User, ShoppingBag, Menu, X } from "lucide-react";
import BDLogo from "@/components/BDLogo";
import { brand, navigation } from "@/mock";
import { useCart } from "@/context/CartContext";

export default function Header({ onOpenCart, onOpenSearch }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { count } = useCart();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      {/* Shipping banner */}
      <div className="bg-[#c60d0d] text-white text-[11px] md:text-[12px] tracking-[0.18em] font-bold text-center py-2 uppercase">
        {brand.shippingBanner}
      </div>

      {/* Main nav */}
      <div
        className={`bg-[#0a0a0a] text-white border-b border-white/10 transition-shadow duration-300 ${
          scrolled ? "shadow-[0_10px_30px_-10px_rgba(0,0,0,0.6)]" : ""
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 flex items-center justify-between h-[68px]">
          <a href="#" className="flex items-center gap-3 shrink-0">
            <div className="h-11 w-11 bg-black rounded-sm overflow-hidden flex items-center justify-center">
              <img
                src={require("@/components/BDLogo").LOGO_URL}
                alt="BD mascot"
                className="h-11 w-11 object-cover object-top scale-[1.8] translate-y-1"
              />
            </div>
            <div className="leading-none">
              <div className="font-black tracking-[0.02em] text-[16px] leading-none">BIG DICK&rsquo;S</div>
              <div className="text-[9px] tracking-[0.3em] text-white/70 mt-[4px] flex items-center gap-1">
                <span className="h-px w-3 bg-[#c60d0d]" />UNDERGEAR<span className="h-px w-3 bg-[#c60d0d]" />
              </div>
            </div>
          </a>

          <nav className="hidden md:flex items-center gap-9">
            {navigation.map((n) => (
              <a
                key={n.label}
                href={n.href}
                className="text-[12px] tracking-[0.18em] font-semibold text-white/90 hover:text-[#ff2626] transition-colors relative group"
              >
                {n.label}
                <span className="absolute -bottom-1 left-0 h-[2px] w-0 bg-[#ff2626] group-hover:w-full transition-all duration-300" />
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-1 md:gap-2">
            <button
              aria-label="Search"
              onClick={onOpenSearch}
              className="p-2 hover:text-[#ff2626] transition-colors"
            >
              <Search size={20} strokeWidth={2} />
            </button>
            <button aria-label="Account" className="p-2 hover:text-[#ff2626] transition-colors hidden sm:inline-flex">
              <User size={20} strokeWidth={2} />
            </button>
            <button
              aria-label="Cart"
              onClick={onOpenCart}
              className="relative p-2 hover:text-[#ff2626] transition-colors"
            >
              <ShoppingBag size={20} strokeWidth={2} />
              <span className="absolute -top-0.5 -right-0.5 bg-[#c60d0d] text-white text-[10px] font-bold min-w-[18px] h-[18px] rounded-full flex items-center justify-center px-1">
                {count}
              </span>
            </button>
            <button
              className="md:hidden p-2"
              onClick={() => setMobileOpen((s) => !s)}
              aria-label="Menu"
            >
              {mobileOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        <div
          className={`md:hidden overflow-hidden transition-[max-height] duration-300 ease-out ${
            mobileOpen ? "max-h-96" : "max-h-0"
          }`}
        >
          <div className="px-6 pb-6 pt-2 flex flex-col gap-4 bg-[#0a0a0a] border-t border-white/10">
            {navigation.map((n) => (
              <a
                key={n.label}
                href={n.href}
                onClick={() => setMobileOpen(false)}
                className="text-sm tracking-[0.18em] font-semibold text-white/90 hover:text-[#ff2626]"
              >
                {n.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}
